import { Button } from '@mui/material'
import { ArrowBack } from '@mui/icons-material'
import { t } from 'i18next'

type ReturnButtonProps = {
  onClick: () => void
}

const ReturnButton = ({
  onClick,
}: ReturnButtonProps) => {
  
  return (
    <Button
      onClick={onClick}
      variant="text"
      color="secondary"
      startIcon={<ArrowBack />}
      size="small"
      sx={{ width: 'fit-content', ml: -3 }}
      aria-label={t('components.notificationSidebar.return')}
    >
      {t('components.notificationSidebar.return')}
    </Button>
  )
}

export default ReturnButton